export default "__VITE_ASSET__fb2ab03f__"